// src/config/routesConfig.js
import HomeIcon           from '@mui/icons-material/Home';
import PriceCheck         from '@mui/icons-material/PriceCheck';
import ShoppingCartIcon   from '@mui/icons-material/ShoppingCart';
import StorefrontIcon     from '@mui/icons-material/Storefront';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HistoryIcon from '@mui/icons-material/History';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StarsIcon from '@mui/icons-material/Stars';

import ListProducts           from '../pages/ListProducts';
import UpdatePrice            from '../pages/UpdatePrice';
import Checkout               from '../pages/Checkout';
import OrderList              from '../pages/OrderList';
import CustomerPOS            from '../pages/CustomerPOS';
import Sale                   from '../pages/Sale';
import NotificationSettings   from '../pages/NotificationSettings';
import ActivityLog            from '../pages/ActivityLog';
import Promotions             from '../pages/Promotions';
import Loyalty                from '../pages/Loyalty';
import ShippingSettings       from '../pages/ShippingSettings';
import InsightConsole         from '../pages/InsightConsole';
import MyTasks                from '../pages/MyTasks';
// import SpecialPage        from '../components/SpecialPage';

// แต่ละ route จะกำหนด path, icon, label, component, และเงื่อนไข permission ไว้ตรงนี้เลย
export const routesConfig = [
  {
    path: '/',
    label: 'สินค้า',
    icon: <HomeIcon />,
    component: ListProducts,
    permission: {},
    showInNav: false
  },
  {
    path: '/updatePrice',
    label: 'อัพเดทราคา',
    component: UpdatePrice,
    permission: { minLevel: 2 },
    showInNav: true
  },
  {
    path: '/checkout/:doc_no',
    label: 'Checkout',
    icon: <ShoppingCartIcon />,
    component: Checkout,
    permission: {
      requiredDepts: ['ฝ่ายขาย','แผนกธุรการเซลล์'],
      orMinLevel: 2,
      orDev: true
    },
    showInNav: false
  },
  {
    path: '/checkout',
    label: 'Checkout',
    icon: <ShoppingCartIcon />,
    component: Checkout,
    permission: {
      requiredDepts: ['ฝ่ายขาย','แผนกธุรการเซลล์'],
      orMinLevel: 2,
      orDev: true
    },
    showInNav: false
  },
  {
    path: '/orderlist',
    label: 'ออเดอร์',
    component: OrderList,
    permission: {},
    showInNav: true
  },
  {
    path: '/notification-settings',
    label: 'ตั้งค่าการแจ้งเตือน',
    component: NotificationSettings,
    permission: {},
    showInNav: false,
  },
  {
    path: '/activity-log',
    label: 'ประวัติการใช้งาน',
    icon: <HistoryIcon />,
    component: ActivityLog,
    permission: {},
    showInNav: false,
  },
  {
    path: '/promotions',
    label: 'โปรโมชัน',
    icon: <LocalOfferIcon />,
    component: Promotions,
    permission: { minLevel: 2 },
    showInNav: false,
  },
  {
    path: '/loyalty',
    label: 'แต้มสะสม',
    icon: <StarsIcon />,
    component: Loyalty,
    permission: { minLevel: 2 },
    showInNav: false,
  },
  {
    path: '/shipping-settings',
    label: 'ตั้งค่าค่าขนส่ง',
    component: ShippingSettings,
    permission: { minLevel: 2 },
    showInNav: false,
  },
  {
    path: '/my-tasks',
    label: 'insight ของฉัน',
    component: MyTasks,
    permission: {}, // หน้าแสดงข้อความเองถ้ายังไม่ได้เปิดใช้ — server ตรวจ persona ทุก endpoint
    showInNav: false,
  },
  {
    path: '/insight-console',
    label: 'Insight Console',
    component: InsightConsole,
    permission: { insightSupport: true },
    showInNav: false,
  },
//   {
//     path: '/customerpos',
//     label: 'Customer POS',
//     icon: <StorefrontIcon />,
//     component: CustomerPOS,
//     permission: {
//       requiredDepts: ['ฝ่ายขาย','แผนกธุรการออกบิล']
//     },
//     showInNav: false
//   },
//   {
//     path: '/sale',
//     label: 'Sale',
//     icon: <ShoppingCartIcon />,
//     component: Sale,
//     permission: { minLevel: 1 },
//     showInNav: false
//   },
//   {
//     path: '/special',
//     label: 'Special',
//     icon: <StorefrontIcon />,
//     component: SpecialPage,
//     permission: { exactLevels: [2,4] },
//     showInNav: false
//   },
//   {
//     path: '/checkout',
//     label: 'Checkout',
//     icon: <ShoppingCartIcon />,
//     component: Checkout,
//     permission: {
//       minLevel: 2,
//       requiredDepts: ['ฝ่ายขาย','แผนกธุรการออกบิล'],
//       orMinLevel: 3
//     },
//     showInNav: false
//   },
];